<template>
  <div class="image-upload">
    <div class="image-upload__preview">
      <div class="preview-image-wrapper">
        <i
          v-if="imagePath"
          class="fa fa-pencil preview-icon"
          aria-hidden="true"
        ></i>
        <div
          v-if="!imagePath"
          class="preview-image--not-selected"
          @click="openModal"
        >
          No image selected
        </div>
        <img
          v-if="imagePath"
          :src="`${imageThumbPath}`"
          class="preview-image"
          alt=""
          @click="openModal"
        />
      </div>
    </div>
    <div class="image-upload__info">
      <div class="image-details mb-auto">
        <div v-if="requiredDimensions" class="image-details__wrapper">
          <div class="image-details__label">Required Dimensions</div>
          <div class="image-details__value">{{ requiredDimensions }}</div>
        </div>

        <div v-if="true" class="image-details__wrapper">
          <div class="image-details__label">Description</div>
          <div class="image-details__value">description</div>
        </div>

        <div v-if="imagePath" class="image-details__wrapper">
          <div class="image-details__label">URL</div>
          <div class="image-details__value">{{ imagePath }}</div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-secondary btn-block mt-auto"
        @click="openModal"
      >
        {{ btnLabel ? btnLabel : "Attach image" }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "asset-preview-box",

  data() {
    return {
      isModalVisible: false,
      requiredDimensions: this.setRequiredDimensions
    };
  },

  props: {
    btnLabel: "",
    assetContext: "",
    imagePath: "",
    setRequiredDimensions: ""
  },

  computed: {
    assetType() {
      var regex = /(?:\.([^.]+))?$/
      
      if (['mp4', 'mov'].indexOf(regex.exec(this.imagePath)[1]) !== -1) {
        return 'movie'
      } else {
        return 'image'
      }
    },

    imageThumbPath() {
      if (this.assetType === 'movie') {
        let imagePaths = this.imagePath.split('/')
        let imagePath = imagePaths[0] + '/thumb_' + imagePaths[1] + '.jpg'
        return this.$store.state.assetsPath + imagePath
      } else {
        return this.$store.state.assetsPath + this.imagePath
      }
    }
  },

  methods: {
    openModal() {
      this.$emit("openAssetLibrary", this.assetContext);
    }
  }
};
</script>
<style lang="scss" scoped>
.image-upload {
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 600px;
  width: 100%;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }

  &__preview {
    cursor: pointer;
    padding: 8px;
    position: relative;
    width: 100%;

    @media (min-width: 768px) {
      width: 400px;
    }

    .preview-image-wrapper {
      background-image: linear-gradient(
          45deg,
          #eee 25%,
          transparent 25%,
          transparent 75%,
          #eee 75%,
          #eee 100%
        ),
        linear-gradient(
          45deg,
          #eee 25%,
          white 25%,
          white 75%,
          #eee 75%,
          #eee 100%
        );
      background-position: 0px 0px, 10px 10px;
      background-size: 20px 20px;
      border-radius: 4px;
      height: 100%;
      overflow: hidden;
      position: relative;
      transition: all 200ms ease-in-out;
      width: 100%;

      &:hover {
        .preview-image {
          opacity: 1;
          transform: scale(1.03);
        }

        .preview-icon {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1.5);
        }
      }
    }

    .preview-image {
      height: 100%;
      object-fit: cover;
      opacity: 1;
      transform: scale(1.01);
      transition: all 200ms ease-in-out;
      width: 100%;

      &--not-selected {
        align-items: center;
        color: #000;
        display: flex;
        height: 100%;
        justify-content: center;
        min-height: 100px;
      }
    }

    .preview-icon {
      color: #fff;
      font-size: 20px;
      left: 50%;
      opacity: 0;
      position: absolute;
      top: 50%;
      text-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
      transform: translate(-50%, -50%) scale(1);
      transition: all 200ms ease-in-out;
      z-index: 1;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 8px;
    width: 100%;

    @media (min-width: 768px) {
      padding: 8px 8px 8px 0;
      width: 200px;
    }

    .image-details {
      &__wrapper {
        margin-bottom: 10px;
      }

      &__label {
        font-size: 14px;
        font-weight: 500;
      }

      &__value {
        font-size: 12px;
        font-weight: 400;
        opacity: 0.8;
      }
    }
  }
}
</style>
